<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">分配角色</div>
      </zj-layout-header>
      <zj-layout-main style="padding-top:0;">
        <span class="small_title">基本信息</span>
        <el-form ref="form" :model="form" label-width="80px" style="margin-top:20px;">
          <el-row>
            <el-col :span="8" :offset="2">
              <el-form-item label="用户昵称">
                <el-input v-model="form.nickName" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="2">
              <el-form-item label="登录账号">
                <el-input  v-model="form.userName" disabled />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <span class="small_title">角色信息</span>
        <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table v-loading="loading" :row-key="getRowKey" ref="table" @selection-change="handleSelectionChange" :data="roles.slice((pageNum-1)*pageSize,pageNum*pageSize)">
                <el-table-column type="selection" :reserve-selection="true" width="55" align="center"></el-table-column>
                <el-table-column label="序号" width="60" type="index" align="center"></el-table-column>
                <el-table-column label="角色编号" align="center" prop="roleId" />
                <el-table-column label="角色名称" align="center" prop="roleName" />
                <el-table-column label="权限字符" align="center" prop="roleKey" />
                <el-table-column label="创建时间" align="center" prop="createTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.createTime) }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </div>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageSize"  
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
            v-show="total>0"
          ></el-pagination>
        </zj-layout-footer>
        <el-form label-width="100px">
          <el-form-item style="text-align: center;margin-left:-120px;margin-bottom:0px;">
            <el-button type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="close()">返回</el-button>
          </el-form-item>
        </el-form>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getUserRole, updateUserRole } from "@/api/system/permission/user";
export default {
  name: "UserRoleView",
  controller: "UI",
  action: "UserRoleView",
  data() {
    return {
       // 遮罩层
      loading: true,
      // 分页信息
      total: 0,
      pageNum: 1,
      pageSize: 10,
      // 选中角色编号
      roleIds:[],
      // 角色信息
      roles: [],
      // 用户信息
      form: {}
    };
  },
  created() {
    const userId = this.$route.query && this.$route.query.userId;
    if (userId) {
      this.loading = true;
      getUserRole(userId).then((response) => {
        this.form = response.data.user;
        this.roles = response.data.roles;
        this.total = this.roles.length;
        this.$nextTick(() => {  //设置选中状态
          this.roles.forEach((row) => {
            if (row.flag) {
              this.$refs.table.toggleRowSelection(row);
            }
          });
        });
        this.loading = false;
      });
    }
  },
  methods: {
    // 单击选中行数据
    clickRow(row) {
      this.$refs.table.toggleRowSelection(row);  //切换行选中状态
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.roleIds = selection.map((item) => item.roleId);
    },
    // 保存选中的数据编号
    getRowKey(row) {
      return row.roleId;
    },
    // 提交
    submitForm() {
      const userId = this.form.userId;
      const roleIds = this.roleIds.join(",");
      updateUserRole({ userId: userId, roleIds: roleIds }).then((response) => {
        this.$message({type: "success", message: "授权成功"});
        this.logInfo.ActionName = "用户分配角色";
        this.logInfo.LogMessage = "用户分配角色成功";
        this.logInfo.ModuleName = "账号管理";
        this.logInfo.PageName = "用户分配角色页面";
        this.addOperationLog();
        this.close();
      });
    },
    // 返回
    close() {
      this.$router.go(-1);
    },

    // 点击每页显示的条数
    handleSizeChange(val){
      this.pageSize = val;
    },
    // 点击切换到某页
    handleCurrentChange(val){
      this.pageNum = val;
    }
  },
};
</script>
<style scoped>
.small_title{
  font-weight: bold;
  border-bottom: 0.1rem dashed #2bc2ff;
  color: #2bc2ff;
  height: 4rem;
  position: relative;
}
</style>